/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import Button from '@mui/material/Button';
import React from 'react';

const getColor = (theme, props) => {
	if (props.disabled) {
		return '#CCCCCC';
	}
	return theme.palette.mode === 'dark' ? 'white' : '#222222';
};


export default function DialogButton(props) {
	const {margin, marginV, defaultButton, ...rest} = props;
	return (
		<Button
			{...rest}
			autoFocus={defaultButton===true}
			variant={defaultButton ? 'contained' : 'outlined'}
			style={{
				// eslint-disable-next-line no-nested-ternary
				margin: props.margin ? '10px' : (marginV ? '10px 0px' : '0px'),
				borderColor: (theme) => getColor(theme, props),
				color: (theme) => getColor(theme, props),
				...props.style
			}}
		>
			{props.children}
		</Button>
	);
}
